import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'

import NewRequestedProducts from './NewRequestedProducts/NewRequestedProducts'
import ProductsToReturn from './ProductsToReturn/ProductsToReturn'
import { getNewRequestedProducts } from './helpers'
import * as Styles from './styles'

const ProductSelection = () => {
  const { t } = useTranslation()
  const { rmaInfo } = useContext(RMAContext)

  return (
    <Styles.Container>
      <Text type="titleS">{t('Selección de productos')}</Text>
      {rmaInfo?.items?.length > 0 ? (
        <>
          <ProductsToReturn productsCount={rmaInfo?.items?.length || 0} />
          <NewRequestedProducts productsCount={getNewRequestedProducts(rmaInfo?.items) || 0} />
        </>
      ) : (
        <Text type="bodyMRegular">{t('Ningún producto seleccionado')}</Text>
      )}
    </Styles.Container>
  )
}

export default ProductSelection
